import { api } from '../api';
import { tags } from '../tags';
import type { AzureCategoryRecord } from '../types';

export const azureCategoryApi = api.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    azureCategory: builder.query<AzureCategoryRecord, void>({
      query: () => 'api/ataazurecategory/all/',
      providesTags: [tags.azureCategory],
      keepUnusedDataFor: 1200,
    }),
  }),
});
